// extracted by mini-css-extract-plugin
export default {"add-entity-save-button-wrapper":"addEntity_add-entity-save-button-wrapper__E3Ro7","entity-detail-label":"addEntity_entity-detail-label__m5BOw"};